<template>
    <div class="col-sm-12">
        <div>
            <table class="table table-striped table-hover table-sticky-header table-responsive" v-if="data">
                <thead>
                    <tr>
                        <th>{{groupByLabel}}</th>
                        <th>Views</th>
                        <th>Unique Views</th>
                        <th>Clicks</th>
                        <th>CTR</th>

                        <th v-if="typeFilter !== 'spend'">Calls</th>
                        <th v-if="typeFilter !== 'spend'">Multi Carrier Leads</th>
                        <th v-if="typeFilter !== 'spend'">Job Board Leads</th>
                        <th v-if="typeFilter !== 'spend'">
                            <el-popover
                                placement="top"
                                title="Conversions"
                                trigger="hover"
                                content="3rd party Landing Page leads">
                                <span slot="reference">Conversions <i class="fa fa-question-circle"></i></span>
                            </el-popover>
                        </th>
                        <th v-if="typeFilter !== 'spend'">Job Adviser</th>
                        <th v-if="typeFilter !== 'spend'">DriverEngage</th>

                        <th v-if="typeFilter !== 'volume'">Calls Spend</th>
                        <th v-if="typeFilter !== 'volume'">MC Leads Spend</th>
                        <th v-if="typeFilter !== 'volume'">Job Board Leads Spend</th>
                        <th v-if="typeFilter !== 'volume'">
                            <el-popover
                                placement="top"
                                title="Conversions Spend"
                                trigger="hover"
                                content="3rd party Landing Page leads">
                                <span slot="reference">Conversions Spend <i class="fa fa-question-circle"></i></span>
                            </el-popover>
                        </th>
                        <th v-if="typeFilter !== 'volume'">Job Adviser Spend</th>
                        <th v-if="typeFilter !== 'volume'">DriverEngage Spend</th>

                        <th v-if="typeFilter === 'volume'">Total Leads</th>
                        <th v-if="typeFilter === 'spend'">Total Spend</th>
                        <th>Total jobs</th>
                    </tr>
                </thead>
                <tbody>
                <tr v-for="row in data">
                    <td style="padding-left: 30px">{{row.date}}</td>
                    <td>{{row.views}}</td>
                    <td>{{row.uniqueViews}}</td>
                    <td>{{row.clicks}}</td>
                    <td>{{percent(row.ctr)}}</td>

                    <td v-if="typeFilter !== 'spend'">{{row.calls}}</td>
                    <td v-if="typeFilter !== 'spend'">{{(row.mcApps)}}</td>
                    <td v-if="typeFilter !== 'spend'">{{(row.directApps)}}</td>
                    <td v-if="typeFilter !== 'spend'">{{(row.conversionsApps)}}</td>
                    <td v-if="typeFilter !== 'spend'">{{(row.jobadviserApps)}}</td>
                    <td v-if="typeFilter !== 'spend'">{{(row.driverengageApps)}}</td>

                    <td v-if="typeFilter !== 'volume'">{{money(Number(row.callsSpend))}}</td>
                    <td v-if="typeFilter !== 'volume'">{{money(Number(row.mcAppsSpend))}}</td>
                    <td v-if="typeFilter !== 'volume'">{{money(Number(row.directAppsSpend))}}</td>
                    <td v-if="typeFilter !== 'volume'">{{money(Number(row.conversionsSpend))}}</td>
                    <td v-if="typeFilter !== 'volume'">{{money(Number(row.jobadviserSpend))}}</td>
                    <td v-if="typeFilter !== 'volume'">{{money(Number(row.driverengageSpend))}}</td>

                    <td v-if="typeFilter === 'volume'">{{row.totalApps}}</td>
                    <td v-if="typeFilter === 'spend'">{{row.totalSpend}}</td>
                    <td>{{(row.totalJobs)}}</td>
                </tr>
                <tr style="background: lightcyan">
                    <td style="font-weight: bold">Total</td>
                    <td>{{ totalRow.views }}</td>
                    <td>{{ totalRow.uniqueViews }}</td>
                    <td>{{ totalRow.clicks }}</td>
                    <td>{{ percent(totalRow.ctr) }}</td>

                    <td v-if="typeFilter !== 'spend'">{{ totalRow.calls }}</td>
                    <td v-if="typeFilter !== 'spend'">{{ totalRow.mcApps }}</td>
                    <td v-if="typeFilter !== 'spend'">{{ totalRow.directApps }}</td>
                    <td v-if="typeFilter !== 'spend'">{{ totalRow.conversionsApps }}</td>
                    <td v-if="typeFilter !== 'spend'">{{ totalRow.jobadviserApps }}</td>
                    <td v-if="typeFilter !== 'spend'">{{ totalRow.driverengageApps }}</td>

                    <td v-if="typeFilter !== 'volume'">{{ money(totalRow.callsSpend) }}</td>
                    <td v-if="typeFilter !== 'volume'">{{ money(totalRow.mcAppsSpend) }}</td>
                    <td v-if="typeFilter !== 'volume'">{{ money(totalRow.directAppsSpend) }}</td>
                    <td v-if="typeFilter !== 'volume'">{{ money(totalRow.conversionsSpend) }}</td>
                    <td v-if="typeFilter !== 'volume'">{{ money(totalRow.jobadviserSpend) }}</td>
                    <td v-if="typeFilter !== 'volume'">{{ money(totalRow.driverengageSpend) }}</td>

                    <td v-if="typeFilter === 'volume'">{{totalRow.totalApps}}</td>
                    <td v-if="typeFilter === 'spend'">{{money(totalRow.totalSpend)}}</td>
                    <td>{{totalRow.totalJobs}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'data',
            'typeFilter',
            'displayIntelliappCount',
            'groupBy',
        ],
        computed: {
            totalRow() {
                let uniqueViews = _.sumBy(this.data, item => Number(item.uniqueViews));
                let clicks = _.sumBy(this.data, item => Number(item.clicks));
                return {
                    'views': _.sumBy(this.data, item => Number(item.views)),
                    'uniqueViews': uniqueViews,
                    'clicks': clicks,
                    'calls': _.sumBy(this.data, item => Number(item.calls)),
                    'directApps': _.sumBy(this.data, item => Number(item.directApps)),
                    'conversionsApps': _.sumBy(this.data, item => Number(item.conversionsApps)),
                    'mcApps': _.sumBy(this.data, item => Number(item.mcApps)),
                    'jobadviserApps': _.sumBy(this.data, item => Number(item.jobadviserApps)),
                    'driverengageApps': _.sumBy(this.data, item => Number(item.driverengageApps)),
                    'ctr': uniqueViews > 0 ? (clicks / uniqueViews) : 0,
                    'displayedJobs': '',
                    'directAppsSpend': _.sumBy(this.data, item => Number(item.directAppsSpend)),
                    'conversionsSpend': _.sumBy(this.data, item => Number(item.conversionsSpend)),
                    'mcAppsSpend': _.sumBy(this.data, item => Number(item.mcAppsSpend)),
                    'callsSpend': _.sumBy(this.data, item => Number(item.callsSpend)),
                    'jobadviserSpend': _.sumBy(this.data, item => Number(item.jobadviserSpend)),
                    'driverengageSpend': _.sumBy(this.data, item => Number(item.driverengageSpend)),
                    'totalApps': _.sumBy(this.data, item => Number(item.totalApps)),
                    'totalSpend': _.sumBy(this.data, item => Number(item.totalSpend)),
                    'totalJobs': '',
                };
            },
            groupByLabel() {
                return this.groupBy.charAt(0).toUpperCase() + this.groupBy.slice(1);
            },
        },
    }
</script>

<style scoped>
    /* Unfortunately this sticky-footer solution is not compatible with "table-responsive" ("overflow-x: auto" on a parent element disables the sticky header) */
    .table-sticky-header {
        position: relative;
        border-collapse: collapse;
        background: #fff;
    }
    .table-sticky-header th {
        position: -webkit-sticky;
        position: sticky;
        top: 0;
        z-index: 10;
        background: #F4F6F6;
    }
</style>
